import React from 'react';
import { Path, Svg } from 'react-native-svg';

interface ExternalLinkIconProps {
  color?: string;
}

export const ExternalLinkIcon: React.FC<ExternalLinkIconProps> = ({
  color = '#000000'
}) => {
  return (
    <Svg width={20} height={20} viewBox="0 0 24 24" fill="none">
      <Path
        d="M14 3V5H17.59L7.76 14.83L9.17 16.24L19 6.41V10H21V3H14Z"
        fill={color}
      />
      <Path
        d="M19 19H5V5H12V3H5C3.89 3 3 3.9 3 5V19C3 20.1 3.89 21 5 21H19C20.1 21 21 20.1 21 19V12H19V19Z"
        fill={color}
      />
    </Svg>
  );
}; 